export enum TProductType {
  Jewelry = 223940007,
  Watch = 223940008,
}

export const ProductTypeToName: {[key in TProductType]: string} = {
  [TProductType.Jewelry]: 'Jewelry',
  [TProductType.Watch]: 'Watch',
};
